import React, { useState, useRef, useEffect } from 'react';
import UnifiedForm from './Components/UnifiedForm';
import { useTranslation } from 'react-i18next';
import './i18n';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import { FaUsers, FaSignOutAlt, FaIdCard } from "react-icons/fa";
import JsBarcode from "jsbarcode";
import html2canvas from "html2canvas";
import { HiDownload } from "react-icons/hi"; // import download icon
import { FaMale, FaFemale, FaTransgenderAlt } from "react-icons/fa";
import PatientOpCard from "./Components/PatientOpCard";

function App() {
  const navigate = useNavigate();
  const opCardRef = useRef(null);
  const { t, i18n } = useTranslation();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [otpVerified, setOtpVerified] = useState(
    localStorage.getItem("otpVerified") === "true"
  );
  const [isInsideApp, setIsInsideApp] = useState(false);
  const selectedPatient = JSON.parse(localStorage.getItem("patient") || "{}");
  const patientName = selectedPatient?.firstName || "Guest";
  const [showOpCard, setShowOpCard] = useState(false);

  const profilePic = selectedPatient?.profile_pic?.trim()
    ? selectedPatient.profile_pic
    : "/Images/default-avatar.png";

  const storedPatients = JSON.parse(localStorage.getItem("patients") || "[]");
  const hasMultiplePatients = storedPatients.length > 1;

  const dropdownRef = useRef(null);
  const barcodeRef = useRef(null);
  useEffect(() => {
    if (showOpCard && barcodeRef.current && selectedPatient.patientId) {
      JsBarcode(barcodeRef.current, selectedPatient.patientId, {
        format: "CODE128",
        width: 2,
        height: 50,
        displayValue: false,
        margin: 0
      });
    }
  }, [showOpCard, selectedPatient.patientId]);
  const logo = process.env.REACT_APP_HOSPITAL_LOGO;
  const defaultLang = process.env.REACT_APP_DEFAULT_LANG || 'en';
  const hospitalName = process.env.REACT_APP_PAY_HOSPITAL_NAME;
  const OpRow = ({ label, value }) => (
    <div className="flex justify-between">
      <span className="font-medium text-gray-600 dark:text-gray-400">{label}</span>
      <span className="font-semibold text-gray-900 dark:text-gray-100">
        {value || "-"}
      </span>
    </div>
  );
  const forceLogout = () => {
    localStorage.clear();
    setOtpVerified(false);
    navigate("/otp-verification", { replace: true });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const lsVal = localStorage.getItem("otpVerified") === "true";
      if (lsVal !== otpVerified) {
        setOtpVerified(lsVal);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [otpVerified]);

  useEffect(() => {
    const checkResume = () => {
      const last = localStorage.getItem("lastActiveAt");
      const timeout =
        parseInt(process.env.REACT_APP_INACTIVITY_TIMEOUT_IN_MS, 10) || 600000;

      if (!last) {
        localStorage.setItem("lastActiveAt", Date.now().toString());
        return;
      }

      if (Date.now() - Number(last) > timeout) {
        forceLogout();
      }
    };


    const handler = () => {
      if (document.visibilityState === "visible") checkResume();
    };

    document.addEventListener("visibilitychange", handler);
    return () => document.removeEventListener("visibilitychange", checkResume);
  }, []);

  useEffect(() => {
    if (!otpVerified) return;

    let timer;
    const timeout =
      parseInt(process.env.REACT_APP_INACTIVITY_TIMEOUT_IN_MS, 10) || 600000;

    console.log(
      "Inactivity timeout (ms):",
      process.env.REACT_APP_INACTIVITY_TIMEOUT_IN_MS,
      "Parsed:",
      parseInt(process.env.REACT_APP_INACTIVITY_TIMEOUT_IN_MS, 10)
    );

    const reset = () => {
      localStorage.setItem("lastActiveAt", Date.now().toString());
      clearTimeout(timer);
      timer = setTimeout(forceLogout, timeout);
    };

    ["touchstart", "touchmove", "keydown"].forEach(e =>
      window.addEventListener(e, reset)
    );

    reset();

    return () => {
      clearTimeout(timer);
      ["touchstart", "touchmove", "keydown", "mousemove", "mousedown"].forEach(e =>
        window.removeEventListener(e, reset)
      );
    };
  }, [otpVerified]);


  // Apply default language from env on app load
  useEffect(() => {
    i18n.changeLanguage(defaultLang);
  }, [defaultLang, i18n]);

  const changeLanguage = (e) => {
    i18n.changeLanguage(e.target.value);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Initialize OTP state from localStorage on mount
  useEffect(() => {
    setOtpVerified(localStorage.getItem('otpVerified') === 'true');
  }, []);

  // Optional: listen to localStorage changes (if OTP verified in another tab)
  useEffect(() => {
    const handleStorageChange = () => {
      setOtpVerified(localStorage.getItem("otpVerified") === "true");
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);
  useEffect(() => {
    if (otpVerified) {
      localStorage.setItem("lastActiveAt", Date.now().toString());
    }
  }, [otpVerified]);
  const handleLogout = () => {
    localStorage.clear();
    setOtpVerified(false);
    setIsInsideApp(false);

    setDropdownOpen(false);
    window.location.reload();
  };

  return (

    <div className="min-h-screen px-2 py-4 font-sans
  bg-gradient-to-br from-blue-200 via-cyan-200 to-teal-200
  dark:from-gray-900 dark:via-gray-800 dark:to-gray-700
  transition-colors duration-500"
    >

      <div className="max-w-6xl mx-auto">

        {/* ========== HEADER ========== */}
        {/* ========== HEADER ========== */}
        <div className="mb-2 sm:mb-3 overflow-visible relative z-40">
          <div className="backdrop-blur-xl bg-white/70 dark:bg-gray-900/70
        border border-white/40 dark:border-gray-700/40
        rounded-2xl shadow-lg px-4 py-3 sm:px-6 sm:py-4 relative">

            {/* Row 1 — Hospital Name */}
            {otpVerified && (
              <div className="flex items-center justify-center gap-3 mb-3">
                <img src={logo} alt="Logo" className="h-10 sm:h-12 w-auto" />
                <h1 className="text-lg sm:text-2xl md:text-3xl font-bold tracking-wide uppercase
               text-[#0F4C81] dark:text-[#6FB4FF] truncate">
                  {hospitalName}
                </h1>
              </div>
            )}

            {/* Row 2 — Left + Right */}
            <div className="flex items-center justify-between gap-4 flex-wrap">

              {/* Left — Logo + App Name */}
              <div className="flex items-center gap-3 min-w-0">
                {!otpVerified && (
                  <img src="Images/TriloLogo_TRSP.png" alt="Logo" className="h-9 sm:h-10 w-auto" />
                )}

                <div className="truncate">
                  {!otpVerified && (
                    <p className="text-xs sm:text-sm font-semibold text-[#1672B9] dark:text-[#6FB4FF]">
                      {t("login.companyName")}
                    </p>
                  )}

                  <p className={`font-extrabold tracking-wide truncate
    bg-gradient-to-r from-blue-700 via-cyan-600 to-teal-500
    dark:from-blue-400 dark:via-cyan-300 dark:to-teal-200
    text-transparent bg-clip-text drop-shadow-sm
    ${otpVerified ? "text-lg sm:text-2xl" : "text-sm"}`}>
                    {t("login.appName")}
                  </p>
                </div>
              </div>

              {/* Right — Controls */}
              <div className="flex items-center gap-3">

                {/* Language */}
                <select
                  onChange={changeLanguage}
                  value={i18n.language}
                  className="rounded-xl border border-gray-300 dark:border-gray-600
             bg-white/80 dark:bg-gray-800/80 backdrop-blur
             px-3 py-1 text-sm text-gray-700 dark:text-gray-200 shadow-sm"
                >
                  <option value="en">English</option>
                  <option value="ml">മലയാളം</option>
                  <option value="kn">ಕನ್ನಡ</option>
                </select>

                {/* Profile */}
                {logo && otpVerified && (
                  <div className="relative" ref={dropdownRef}>
                    <button
                      onClick={() => setDropdownOpen(p => !p)}
                      className="focus:outline-none ring-2 ring-transparent hover:ring-cyan-400 rounded-full transition"
                    >
                      <img
                        src={profilePic}
                        alt="Profile"
                        className="h-9 w-9 rounded-full object-cover border border-gray-300 dark:border-gray-600 shadow-sm"
                      />
                    </button>

                    {dropdownOpen && (
                      <div className="absolute right-0 mt-2 w-44 rounded-xl overflow-hidden
  bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-xl z-50">

                        <div className="px-4 py-2 text-sm font-semibold text-gray-700 dark:text-gray-200 border-b dark:border-gray-700 flex items-center">
  <span className="truncate">Hi, {patientName}</span>
  <span className="ml-1 flex-shrink-0">👋</span>
</div>



                        {hasMultiplePatients && (
                          <button
                            onClick={() => {
                              const storedPatients = JSON.parse(localStorage.getItem("patients")) || [];
                              window.dispatchEvent(new CustomEvent("showPatientPopup", { detail: storedPatients }));
                              setDropdownOpen(false);
                            }}
                            className="group w-full px-4 py-2 text-left text-sm 
        text-gray-800 dark:text-gray-200
        flex items-center gap-2
        cursor-pointer
        hover:bg-blue-50 dark:hover:bg-blue-900/30
        transition-all duration-150"
                          >
                            <FaUsers className="text-blue-500 dark:text-blue-400 transition-transform group-hover:scale-110" />
                            <span className="group-hover:translate-x-0.5 transition-transform">
                              {t("common.switchPatient")}
                            </span>
                          </button>
                        )}

                        <button
                          onClick={() => {
                            setShowOpCard(true);
                            setDropdownOpen(false);
                          }}
                          className="group w-full px-4 py-2 text-left text-sm 
      text-gray-800 dark:text-gray-200
      flex items-center gap-2
      cursor-pointer
      hover:bg-teal-50 dark:hover:bg-teal-900/30
      transition-all duration-150"
                        >
                          <FaIdCard className="text-teal-500 dark:text-teal-400 transition-transform group-hover:scale-110" />
                          <span className="group-hover:translate-x-0.5 transition-transform">
                            {t("common.showOpCard")}
                          </span>
                        </button>

                        <button
                          onClick={handleLogout}
                          className="group w-full px-4 py-2 text-left text-sm 
      text-red-600 dark:text-red-400
      flex items-center gap-2
      cursor-pointer
      hover:bg-red-50 dark:hover:bg-red-900/30
      transition-all duration-150
      border-t border-gray-200 dark:border-gray-700"
                        >
                          <FaSignOutAlt className="text-red-500 dark:text-red-400 transition-transform group-hover:scale-110" />
                          <span className="group-hover:translate-x-0.5 transition-transform">
                            {t("common.logout")}
                          </span>
                        </button>

                      </div>

                    )}
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>

        <UnifiedForm
          onOtpVerified={() => {
            console.log("🔥 onOtpVerified fired");

            const now = Date.now().toString();
            localStorage.setItem("lastActiveAt", now);
            localStorage.setItem("otpVerified", "true");   // ← ADD THIS
            setOtpVerified(true);
            setIsInsideApp(true);
          }}
        />
        {/* ===== Static Footer Banner ===== */}
        {/* ===== Footer Banner Like Header ===== */}
        <div className="mt-4">
          <div className="backdrop-blur-xl bg-white/70 dark:bg-gray-900/70
                  border border-white/40 dark:border-gray-700/40
                  rounded-2xl shadow-lg px-4 py-3 sm:px-6 sm:py-4
                  text-center text-xs sm:text-sm font-medium
                  text-gray-800 dark:text-gray-200">
            {t("footer.copyright", { year: new Date().getFullYear() })}
          </div>
        </div>


      </div >
      <PatientOpCard
        show={showOpCard}
        onClose={() => setShowOpCard(false)}
        selectedPatient={selectedPatient}
        hospitalName={hospitalName}
        logo={logo}
      />



      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="colored"
        toastClassName="rounded-md shadow-lg"
      />

    </div >
  );

}



export default App;
